import React from "react";
import "./news.css";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";
import { useState } from "react";

import { useRef } from "react";

import { useLocation } from "react-router-dom";

import axios from "axios";
import { ApiContext } from "../../Context/Context";
import { use, useContext, useEffect } from "react";
import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
} from "../../Services/ApiCall";
import FeaturedProperty from "../../Common/FeaturedProperties";
import ProjectsComp from "../../Common/Projects";
import NearByProperties from "../../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  BaseUrl,
  apiUrl_dialerp,
  setLogindata,
  setUserdata,
} from "../../Services/Urls";
import FilterParams from "../../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../../Common/SelectDialog ";
import AmenitiesDialog from "../../Common/AmenitiesDialog";
import { decryptOtp, formatDaysAgo } from "../../Services/Helper";
import {
  callApi,
  makeApiRequest,
  callAzureOpenAI,
} from "../../Services/ApiService";

import { toast } from "react-toastify";
import SucessDialog from "../../Common/Dialog/SucessDialog";
import {
  formatIndianAmount,
  removeSpecialCharacters,
} from "../../Services/Helper";
import { useParams } from "react-router-dom";

const data = [
  {
    title: "Mumbai Metro Line 3: Route map, stations list and latest...",
    date: "February 25, 2025",
  },
  {
    title: "Home loan interest rates in 2025: Compare rates from top...",
    date: "February 23, 2025",
  },
  {
    title: "Is Faridabad the next Gurgaon? Infrastructure and location...",
    date: "February 21, 2025",
  },
  {
    title: "RERA registration: How to check RERA number of any project...",
    date: "February 20, 2025",
  },
  {
    title: "Save 72% on premiums when you choose online home loan...",
    date: "February 18, 2025",
  },
];

export default function NewsDetails() {
    const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get("id");

  const [newsData, setnewsData] = useState(null);
  const [heronewsData, setheronewsData] = useState(null);
  const [loader, setLoader] = useState(true);

  const [categoryData, setcategoryData] = useState([
    {
      id: 0,
      name: "All",
      colorCode: "#000000",
    },

    {
      id: 1,
      name: "Property Trends",
      colorCode: "#000000",
    },
    {
      id: 2,
      name: "Home Loans",
      colorCode: "#000000",
    },
    {
      id: 3,
      name: "Buying Guide",
      colorCode: "#000000",
    },
    {
      id: 4,
      name: "Rent",
      colorCode: "#000000",
    },
    {
      id: 5,
      name: "City Transport",
      colorCode: "#000000",
    },
    {
      id: 6,
      name: "Legal & Tax",
      colorCode: "#000000",
    },
    {
      id: 7,
      name: "Home Decor",
      colorCode: "#000000",
    },
    {
      id: 8,
      name: "NRI Corner",
      colorCode: "#000000",
    },
  ]);

  const [selecetedCategory, setselecetedCategory] = useState({
    id: 0,
    name: "All",
    colorCode: "#000000",
  });

  useEffect(() => {
    getNews(selecetedCategory);
    getNewsDetails();
  }, []);

  const getNews = (category) => {
    const filter =
      category?.id != 0 ? `{'ArticleTypeID':{\$eq:${category?.id}}}` : "{}";

    getRecords(429, 10, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setLoader(false);
          setnewsData(data?.response?.records || []);
          //   setheronewsData(data?.response?.records[0] || null);
        } else {
          setnewsData(null);
          //   setheronewsData(null);
          setLoader(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setLoader(false);
      }
    });
  };

  const getNewsDetails = () => {
    const filter = `{'ArticleID':{\$eq:${id}}}`;

    getRecords(429, 10, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setLoader(false);
          // setnewsData(data?.response?.records || []);
          setheronewsData(data?.response?.records[0] || null);
        } else {
          //   setnewsData(null);
          setheronewsData(null);
          setLoader(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setLoader(false);
      }
    });
  };

  return (
    <div className="page-wrapper">
      <Header />

      <section className="property-wrap ptb-100">
        <div className="container">
          {/* Breadcrumb */}
          <div className="breadcrumb">
            Home &nbsp;&gt;&nbsp; News & Articles &nbsp;&gt;&nbsp;Home Loans
          </div>
          {/* Hero */}

          {/* Layout */}
          <div className="grid">
            {/* LEFT */}
            <div className="left">
              <div className="page">
                <div className="container">
                  {/* Header */}
                  <div className="tag-row">
                    <span className="tag">{heronewsData?.ArticleType}</span>
                    {/* <span className="read">6 min read</span> */}
                  </div>

                  <h1 className="title">{heronewsData?.ArticleTitle}</h1>

                  <div className="author">
                    <div className="avatar">
                      {heronewsData?.ArticleAuthor?.split(" ")
                        .slice(0, 2)
                        .map((word) => word[0])
                        .join("")
                        .toUpperCase()}
                    </div>
                    <div>
                      <div className="name">{heronewsData?.ArticleAuthor}</div>
                      <div className="date">
                        {heronewsData?.cDt?.split(" ")[0] || ""}
                      </div>
                    </div>
                  </div>

                  {/* Hero Image */}
                  <img src={heronewsData?.Images} alt="home" className="hero" />

                  {/* Content */}
                  <p className="para">
                    <b>{heronewsData?.ArticleContent}</b>
                  </p>

                  {/* <h2 className="section-title">Current Market Scenario</h2>
                  <p className="para small">
                    The home loan market in 2025 continues to evolve with
                    competitive rates and innovative products. Major banks and
                    housing finance companies are offering attractive interest
                    rates ranging from 8.5% to 9.5% per annum, depending on the
                    borrower's credit profile and loan amount.
                  </p> */}

                  {/* <h2 className="section-title">Top Lenders Comparison</h2>
                  <div className="card">
                    {[
                      { name: "State Bank of India", rate: "8.50% - 9.25%" },
                      { name: "HDFC Bank", rate: "8.60% - 9.30%" },
                      { name: "ICICI Bank", rate: "8.65% - 9.35%" },
                      { name: "Axis Bank", rate: "8.70% - 9.40%" },
                    ].map((item, i) => (
                      <div key={i} className="row">
                        <span>{item.name}</span>
                        <span className="rate">{item.rate}</span>
                      </div>
                    ))}
                  </div>

                  <h2 className="section-title">
                    Tips for Getting the Best Rate
                  </h2>
                  <ul
                    className="list"
                    style={{
                      borderBottom: "1px solid #f2f2f2",
                      paddingBottom: 10,
                    }}
                  >
                    <li>
                      Maintain a credit score above 750 for preferential rates
                    </li>
                    <li>
                      Compare offers from at least 3-4 lenders before deciding
                    </li>
                    <li>
                      Consider the processing fees and other charges in total
                      cost
                    </li>
                    <li>
                      Opt for a shorter tenure if you can afford higher EMIs
                    </li>
                    <li>Check for special rates for women borrowers</li>
                  </ul> */}

                  <div className="sharearticle">
                    <div className="share">Share this article</div>

                    <div className="social">
                      <div className="circle fb">f</div>
                      <div className="circle tw">x</div>
                      <div className="circle ln">in</div>
                      <div className="circle wa">w</div>
                    </div>
                  </div>
                  {/* <h2 className="section-title">Related Articles</h2> */}

                  {/* <div className="related">
                    <img
                      src="https://images.unsplash.com/photo-1568605114967-8130f3a36994"
                      alt="related"
                    />
                    <div className="related-content">
                      <span className="tag small-tag">Home Loans</span>
                      <span className="read small-read">6 min read</span>
                      <h3>
                        Save 72% on premiums when you choose online home loan
                        insurance
                      </h3>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div className="right">
              <div className="box">
                <h4>
                  <i
                    className="ri-fire-fill text-orange-500"
                    style={{ color: "#f97316" }}
                  ></i>{" "}
                  Trending Topics
                </h4>
                <ul>
                  {newsData
                    ?.filter((c) => c?.TrendingID === 1)
                    ?.map((data, i) => {
                      return <li>{data?.ArticleTitle}</li>;
                    })}
                </ul>
              </div>

              <div className="box">
                <div className="popular-card">
                  <div className="popular-header">
                    <span className="star">★</span>
                    <h3>Most Popular</h3>
                  </div>

                  <div className="popular-list">
                    {newsData
                      ?.filter((c) => c?.MostPopularID === 1)
                      .map((item, index) => (
                        <div className="popular-item" key={index}>
                          <div className="number">{index + 1}</div>

                          <div className="content">
                            <p className="title">{item.ArticleTitle}</p>
                            <span className="date">
                              {formatDaysAgo(item?.cDt?.split(" ")[0])}
                            </span>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="subscribe">
                <div className="iconnss">
                  <i class="ri-mail-line text-2xl"></i>
                </div>
                <h4>Stay Updated</h4>
                <p>
                  Get the latest real estate news and insights delivered to your
                  inbox.
                </p>
                <input placeholder="Enter your email" />
                <button>Subscribe Now</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

const cards = [
  {
    title: "Home loan interest rates in 2025: Compare rates from top banks",
    tag: "Home Loans",
    time: "6 min read",
    author: "Rahul Mehta",
    date: "February 23, 2025",
    img: "https://images.unsplash.com/photo-1560520031-3a4dc4e9de0c",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
  {
    title:
      "Is Faridabad the next Gurgaon? Infrastructure and location advantages",
    tag: "Property Trends",
    time: "7 min read",
    author: "Sandeep Nayak",
    date: "February 21, 2025",
    img: "https://images.unsplash.com/photo-1505691938895-1758d7feb511",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
  {
    title: "RERA registration: How to check RERA number of any project online",
    tag: "Legal & Tax",
    time: "5 min read",
    author: "Anita Desai",
    date: "February 20, 2025",
    img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
  {
    title: "Save 72% on premiums when you choose online home loan insurance",
    tag: "Home Loans",
    time: "6 min read",
    author: "Vivek Jain",
    date: "February 18, 2025",
    img: "https://images.unsplash.com/photo-1560518883-ce09059eeffa",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
  {
    title:
      "Top 10 Vastu tips for your new home: Direction, placement and remedies",
    tag: "Home Decor",
    time: "9 min read",
    author: "Meera Kapoor",
    date: "February 17, 2025",
    img: "https://images.unsplash.com/photo-1505691938895-1758d7feb511",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
];
